export default function () {
  return {
    beforeCreate(): void {
      // noop
    },

    created(): void {
      // noop
    },

    beforeDestroy(): void {
      // noop
    }
  }

}
